import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-scan-setup-dlg',
  templateUrl: './scan-setup-dlg.component.html',
  styleUrls: ['./scan-setup-dlg.component.scss']
})
export class ScanSetupDlgComponent implements OnInit {

  isWindowsEnvironment: boolean = true;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ScanSetupDlgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log('this.data.message ' + this.data.message);
    this.isWindowsEnvironment = this.data._isWindowsEnvironment;
    if (this.data._message !== '') {
      this.message = this.data._message;
    }
    else {
      this.message = 'Please download the TDOx Service Broker by clicking on the link below and install.  Refresh the page after installing.';
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }

  onOkClick() {
    this.dialogRef.close();
  }
}
